$(document).ready(() => {
	const $anchors = $('[data-anchor]');
	const pageHash = window.location.hash;

	if ($anchors.length && pageHash) {
		const scrollAnchorElem = anchorExistOnPage($anchors, pageHash);

		if (scrollAnchorElem.length) {
			scrollToAnchor(scrollAnchorElem);
		}
	}

	function anchorExistOnPage($elements, hash) {
		return $elements.toArray().filter((elem) => $(elem).data('anchor') == hash);
	}

	function scrollToAnchor(elem) {
		const topPos = $(elem).offset().top;
		const fixedMenuHeight = $('.js-header-top-nav').height();

		$('html')
			.velocity('stop', true)
			.velocity('scroll', {
				offset: topPos - fixedMenuHeight + 'px',
				duration: 400,
				mobileHA: false
			});
	}
});



// WEBPACK FOOTER //
// ./temp/components/anchor/index.js